export default __webpack_public_path__ + "static/media/edit.12117291.svg";